<script>
    import cryptoJS from 'crypto-js'
    import axios from 'axios'
    const encodeKey = cryptoJS.enc.Utf8.parse("6933f0b1a323b98d");
    const encodeIv = cryptoJS.enc.Utf8.parse('0000000000000000');
    const commonUrl = 'https://www.nttrauma.com';
    //const commonUrl = 'http://localhost:9102';
    export default {
        // 请求后台
        postData: function(postUrl,postPara,callbackfun){

            var url = commonUrl+"/api" + postUrl;
            // var url = commonUrl + postUrl;
            var promise = new Promise(function(resolve, reject) {
                axios.post(url,postPara)
                    .then((response) => {
                        resolve( response);
                    })
                    .catch((error) => {
                        reject( error );
                    });
            });
            if(callbackfun){
                promise.then(callbackfun).catch(function(d) {
                    alert(d);
                });
            }
            return promise;
        },
        //登录验证用
    	getLoginJson: function(param){
			return this.getRequestJson({
				username: param.username,
				password: this.getAES(param.password)
			});
		},
    	//修改密码用
        getEditPwdJson: function(param){
			return this.getRequestJson({
				pwd:     this.getAES(param.pwd),
				new_pwd: this.getAES(param.new_pwd),
				re_pwd:  this.getAES(param.re_pwd)
			});
		},
    	//正常的请求验证用
        getCommonJson: function(param){
			if(typeof (param) === 'undefined' || param == null){
					param = {time:new Date()};
			}
			return this.getRequestJson(param);
		},
		//签名验证
        getRequestJson: function (param) {
            var stamp = Date.parse(new Date()) / 1000 + '';
            var appId = 'a1e6d91c6a1a6ea88bb19c21c1259f98';
            var reaction = cryptoJS.SHA1(stamp + appId + JSON.stringify(param));
            return {
                stamp: stamp,
                reaction: reaction.toString(),
                params: param,
            };
        },
        //AES加密
        getAES: function(origin){
            var key = cryptoJS.enc.Utf8.parse('6933f0b1a323b98d');
            var iv  = cryptoJS.enc.Utf8.parse('0000000000000000');
            var originByte = cryptoJS.enc.Utf8.parse(origin);
            var encrypted = cryptoJS.AES.encrypt(originByte, key,
                {
                    iv:iv,
                    mode: cryptoJS.mode.CBC,
                    padding: cryptoJS.pad.ZeroPadding,
                });
            return encrypted.ciphertext.toString();
        },
        getUrlKey: function (name) {
            return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [,""])[1].replace(/\+/g, '%20')) || null
        },
        getNowFormatDate(data) {
            var date;
            if(data){
                date = data;
            }else{
                date = new Date();
            }
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month ;
            return currentdate;
        },
        getFormatDate() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear();
            var month = date.getMonth()+ 1;
            var strDate = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            return year + seperator1 + month;
        },
        jsonPara: function (p) {
            return {"jsonPara":JSON.stringify(p)};
        },
        getJsonPara: function (route){
            if(route.params && route.params.jsonPara){
                return JSON.parse(route.params.jsonPara);
            }
            return {};
        },
        getQueryJsonPara: function (route){
            if(route.query && route.query.jsonPara){
                return JSON.parse(route.query.jsonPara);
            }
            return {};
        },
        encodePara(param){
            let srcs = cryptoJS.enc.Utf8.parse(param);
            let encrypted = cryptoJS.AES.encrypt(srcs,encodeKey,{iv:encodeIv,mode:cryptoJS.mode.CBC,padding:cryptoJS.pad.Pkcs7});
            return encrypted.ciphertext.toString().toUpperCase();
        },
        decodePara(param){
            let encryptedHexStr = cryptoJS.enc.Hex.parse(param);
            let srcs = cryptoJS.enc.Base64.stringify(encryptedHexStr);
            let decrypt = cryptoJS.AES.decrypt(srcs,encodeKey,{iv:encodeIv,mode:cryptoJS.mode.CBC,padding:cryptoJS.pad.Pkcs7 });
            let decryptedStr = decrypt.toString(cryptoJS.enc.Utf8);
            return decryptedStr.toString();
        },
        formatDatetime(data){
            var hasTime = arguments[1] != false ? true : false;//可传第二个参数false，返回yyyy-MM-dd
            var d = new Date(data);
            var year = d.getFullYear();
            var month = (d.getMonth()+1)<10 ? '0'+(d.getMonth()+1) : (d.getMonth()+1);
            var day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
            var hour = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
            var minute = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
            var second = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();
            if(hasTime){
                return [year, month, day].join('-') + " " + [hour, minute, second].join(':');
            }else{
                return [year, month, day].join('-');
            }
        },
        dateDifference(startTime,endTime){
            // let d1 = new Date(faultDate);
            // let d2 = new Date(completeTime);
            var stime =new Date(startTime).getTime();
            var etime = new Date(endTime).getTime();
            if(etime<stime){
                return
            }
            var usedTime = etime - stime;  //两个时间戳相差的毫秒数
            var minutes = Math.floor(usedTime/(60*1000));
            // var time = days;
            return minutes;
        },
        // 数组元素从大到小排序
        sortArray(arr){
　　　　　　　//创建每次循环存储最大值得变量
            var max;
　　　　　　　//遍历数组，默认arr中的某一个元素为最大值，进行逐一比较
            for(var i=0; i<arr.length; i++){
　　　　　　　　　　//外层循环一次，就拿arr[i] 和 内层循环arr.legend次的 arr[j] 做对比
                for(var j=i; j<arr.length; j++){
                    if(arr[i]<arr[j]){
                        //如果arr[j]大就把此时的值赋值给最大值变量max
　　　　　　　　　　　　　　 max=arr[j];
                        arr[j]=arr[i];
                        arr[i]=max;
                    }
                }
            }
            return arr;
        },
        closeDialog(){
          this.allDialog1 = false
          this.allDialog = ''
        },
        openDialog(val){
          let allDialog1 = true
          let allDialog2 = val
          return {
            allDialog1:allDialog1,
            allDialog2:allDialog2
          }
        },

        formatDateForReport(){
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth()+ 1;
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            let endDate = year+'-'+month;
            date.setMonth(date.getMonth() - 11);
            year = date.getFullYear();
            month = date.getMonth()+ 1;
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            let startDate = year+'-'+month;
            return [startDate,endDate]
        },
        compare (prop) {
            return function (obj1, obj2) {
                var val1 = obj1[prop];
                var val2 = obj2[prop];
                if (val1 > val2) {
                    return -1;
                } else if (val1 < val2) {
                    return 1;
                } else {
                    return 0;
                }
            }
        },
        commonUrl,
    }
</script>



// WEBPACK FOOTER //
// src/components/Common.vue